/**
 * Route path constants for the application
 * Single source of truth for all route paths
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PRICING: '/pricing',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  ACCEPT_INVITATION: '/accept-invitation',

  // Onboarding routes
  ONBOARDING: {
    VERIFY_EMAIL: '/onboarding/verify-email',
    CHECKOUT: '/onboarding/checkout',
    SUCCESS: '/onboarding/success',
    PAYMENT_CANCELED: '/onboarding/payment-canceled'
  },

  // Protected routes
  SOCIAL_MEDIA: '/social-media',
  NEWSLETTER: '/newsletter',
  REPORTS: '/reports',
  DASHBOARD: '/dashboard',
  SETTINGS: '/settings',
  SUPPORT: '/support',
  HELP: '/help',
  SPONSORSHIPS: '/sponsorships',
  BRAND_SCOUT: '/brand-scout',
  INVENTORY: '/inventory',
  PARTNERS: '/partners'
} as const
